import { Box } from '@mui/material'
import { Navigate, useParams } from 'react-router-dom'

import { getPage, SectionTab, SectionTabs } from 'components/Tabs'
import { ROUTES } from 'routes'
import { RichPlacementsUrlParams, SectionRouteParam, useSectionTabs } from './useSectionTabs'

export const RichPlacements = (): JSX.Element => {
  const { section: currentSection, workspaceId } = useParams<RichPlacementsUrlParams>()

  const sectionTabs: SectionTab<SectionRouteParam>[] = useSectionTabs()

  if (!workspaceId || !currentSection) {
    return <Navigate to={ROUTES.BASE.NOT_FOUND} />
  }

  return (
    <>
      <Box sx={{ display: 'flex' }}>
        <SectionTabs
          path={ROUTES.GLOBAL_SETUP.DEFAULTS.ROOT}
          sections={sectionTabs}
        />

        <Box sx={{ flexGrow: 1 }}>
          {getPage<SectionRouteParam>(sectionTabs, currentSection, 'multianchor')}
        </Box>
      </Box>
    </>
  )
}
